export default {
  metaTitle: {
    id: 'listings_title',
    defaultMessage: 'My listings',
  },
  title: {
    id: 'listings_title',
    defaultMessage: 'My listings',
  },
  navigation: {
    id: 'listings_title_navigation',
    defaultMessage: 'Options navigation',
  },
  tabActive: {
    id: 'listings_link_active',
    defaultMessage: 'Active',
  },
  tabArchived: {
    id: 'listings_link_archived',
    defaultMessage: 'Archived',
  },
  tabMissingInfos: {
    id: 'listings_link_missing_infos',
    defaultMessage: 'Missing information',
  },
  tabInValidation: {
    id: 'listings_link_in_validation',
    defaultMessage: 'In validation',
  },
  create: {
    id: 'listings_create_offer',
    defaultMessage: 'Create an offer',
  },
  importExport: {
    id: 'listings_button_import_export_label',
    defaultMessage: 'Import/Export',
  },
  managePriceRules: {
    id: 'listings_manage_price_rules',
    defaultMessage: 'Manage price rules',
  },
}
